<template>
	<div>
		<img class="img" src="../../assets/home/bg.png">
		<img class="img" src="../../assets/home/bg2.png">
	</div>
</template>
<script>
	export default {
		data() {
			return {};
		},
		mounted() {},
		methods: {}
	};
</script>
<style scoped lang="less">
	.img {
		width: 100%;
		display: block;
	}
</style>


// WEBPACK FOOTER //
// src/views/home/home.vue